import { render, staticRenderFns } from "./ShotWindow.vue?vue&type=template&id=7d03da22&scoped=true&"
import script from "./ShotWindow.vue?vue&type=script&lang=js&"
export * from "./ShotWindow.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/windowAkawaku.css?vue&type=style&index=0&id=7d03da22&prod&scoped=true&lang=css&"
import style1 from "./ShotWindow.vue?vue&type=style&index=1&id=7d03da22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d03da22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VCol,VDialog,VIcon,VRow})
